"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WrappedComponent = exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _colors = require("HubStyleTokens/colors");

var _ComponentMethods = require("customer-data-ui-utilities/component/ComponentMethods");

var _generalStore = require("general-store");

var _classnames = _interopRequireDefault(require("classnames"));

var _EngagementType = _interopRequireDefault(require("crm_ui/engagements/EngagementType"));

var _ImmutableModel = require("customer-data-objects/model/ImmutableModel");

var _TimelineEventHelpers = require("crm_ui/timeline/helpers/TimelineEventHelpers");

var _IsOptedOutOfEmailDependency = _interopRequireDefault(require("crm_ui/profile/dependencies/IsOptedOutOfEmailDependency/"));

var _immutable = require("immutable");

var _ProfileActionSearch = _interopRequireDefault(require("crm_ui/profile/interactionActions/ProfileActionSearch"));

var _PinnedEngagementDependency = _interopRequireDefault(require("crm_ui/pinnedEngagements/dependencies/PinnedEngagementDependency"));

var _ProfileObjectTypesType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/ProfileObjectTypesType"));

var _ProfileInteractionActionsDropdown = _interopRequireDefault(require("crm_ui/profile/interactionActions/ProfileInteractionActionsDropdown"));

var _ProfileSequencesModalConnector = _interopRequireDefault(require("crm_ui/profile/modals/ProfileSequencesModalConnector"));

var _ProfileTimelineTabs = _interopRequireDefault(require("crm_ui/timeline/components/config/ProfileTimelineTabs"));

var _ProfileTimelineTabsCommunicatorButtons = _interopRequireDefault(require("crm_ui/timeline/components/config/ProfileTimelineTabsCommunicatorButtons"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _SubjectContext = require("crm_ui/profile/SubjectContext");

var _SubjectType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/SubjectType"));

var _TimelineDateRangeDependency = _interopRequireDefault(require("crm_ui/timeline/data/dependencies/TimelineDateRangeDependency"));

var _TimelineEventsDependency = _interopRequireDefault(require("crm_ui/timeline/data/dependencies/TimelineEventsDependency"));

var _TimelineFilters = _interopRequireDefault(require("crm_ui/timeline/components/config/TimelineFilters"));

var _TimelineOverrideFavoriteEventDependency = _interopRequireDefault(require("crm_ui/timeline/data/dependencies/TimelineOverrideFavoriteEventDependency"));

var _TimelineStatusDependency = _interopRequireDefault(require("crm_ui/timeline/data/dependencies/TimelineStatusDependency"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  border-bottom: 1px solid ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var dependencies = {
  dateRange: _TimelineDateRangeDependency.default,
  events: _TimelineEventsDependency.default,
  timelineStatus: _TimelineStatusDependency.default,
  favoriteEventOverride: _TimelineOverrideFavoriteEventDependency.default,
  pinnedEngagement: _PinnedEngagementDependency.default,
  isOptedOutOfEmail: _IsOptedOutOfEmailDependency.default
};

var DividingLineDiv = _styledComponents.default.div.withConfig({
  displayName: "TimelineControls__DividingLineDiv",
  componentId: "sc-17jtcwe-0"
})(_templateObject(), _colors.BATTLESHIP);

var propTypes = {
  activityTabIsSelected: _propTypes.default.bool,
  betTabIsSelected: _propTypes.default.bool,
  defaultSelectedTab: _propTypes.default.string.isRequired,
  events: _TimelineEventHelpers.TimelineEventsPropType,
  hasCommunicatePermissions: _propTypes.default.bool,
  isOptedInToActionsRedesign: _propTypes.default.bool,
  isOptedOutOfEmail: _propTypes.default.bool,
  isUngatedForActionsRedesign: _propTypes.default.bool,
  objectType: _ProfileObjectTypesType.default.isRequired,
  onTabClick: _propTypes.default.func.isRequired,
  pinnedEngagement: _EngagementType.default,
  selectedTab: _propTypes.default.string.isRequired,
  subject: _SubjectType.default,
  timelineStatus: _propTypes.default.instanceOf(_immutable.Map)
};

var TimelineControls =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(TimelineControls, _Component);

  function TimelineControls(props) {
    var _this;

    (0, _classCallCheck2.default)(this, TimelineControls);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TimelineControls).call(this, props));
    (0, _ComponentMethods.bindHandlers)((0, _assertThisInitialized2.default)(_this));
    _this.partial = (0, _ComponentMethods.makePartial)();
    _this.state = {
      isActionSearchOpen: false,
      isSequencesModalOpen: false
    };
    return _this;
  }

  (0, _createClass2.default)(TimelineControls, [{
    key: "getSubjectEmail",
    value: function getSubjectEmail() {
      return (0, _ImmutableModel.getProperty)(this.props.subject, 'email');
    }
  }, {
    key: "getShouldShowSequences",
    value: function getShouldShowSequences() {
      if (!this.props.subject) {
        return false;
      }

      var subjectEmail = this.getSubjectEmail();

      if (subjectEmail) {
        return !this.props.isOptedOutOfEmail;
      }

      return false;
    }
  }, {
    key: "handleToggleSequencesModal",
    value: function handleToggleSequencesModal(shouldSequencesModalBeOpen) {
      this.setState(function (state) {
        if (state.isSequencesModalOpen === shouldSequencesModalBeOpen) {
          return state;
        }

        return {
          isSequencesModalOpen: shouldSequencesModalBeOpen
        };
      });
    }
  }, {
    key: "getShouldShowActionsRedesign",
    value: function getShouldShowActionsRedesign() {
      return this.props.isUngatedForActionsRedesign && this.props.isOptedInToActionsRedesign;
    }
  }, {
    key: "renderCommunicatorButtons",
    value: function renderCommunicatorButtons() {
      if (this.getShouldShowActionsRedesign() || this.props.betTabIsSelected) {
        return null;
      }

      return _react.default.createElement(_ProfileTimelineTabsCommunicatorButtons.default, {
        selected: this.props.selectedTab,
        hasCommunicatePermissions: this.props.hasCommunicatePermissions
      });
    }
  }, {
    key: "renderInteractionActionsDropdown",
    value: function renderInteractionActionsDropdown() {
      if (!this.getShouldShowActionsRedesign()) {
        return null;
      }

      return _react.default.createElement(_ProfileInteractionActionsDropdown.default, {
        disabled: !this.props.hasCommunicatePermissions,
        handleOpenSequencesModal: this.partial(this.handleToggleSequencesModal, true),
        showSequences: this.getShouldShowSequences()
      });
    }
  }, {
    key: "renderProfileActionSearch",
    value: function renderProfileActionSearch() {
      if (!this.props.isUngatedForActionsRedesign || !this.props.isOptedInToActionsRedesign || !this.props.hasCommunicatePermissions) {
        return null;
      }

      return _react.default.createElement(_ProfileActionSearch.default, {
        handleOpenSequencesModal: this.partial(this.handleToggleSequencesModal, true),
        showSequences: this.getShouldShowSequences()
      });
    }
  }, {
    key: "renderProfileSequencesModal",
    value: function renderProfileSequencesModal() {
      var _this$context = this.context,
          subjectId = _this$context.subjectId,
          objectType = _this$context.objectType;

      if (!this.getShouldShowSequences()) {
        return null;
      }

      return _react.default.createElement(_ProfileSequencesModalConnector.default, {
        handleCloseModal: this.partial(this.handleToggleSequencesModal, false),
        isOpen: this.state.isSequencesModalOpen,
        objectType: objectType,
        subjectId: subjectId
      });
    }
  }, {
    key: "renderTabs",
    value: function renderTabs() {
      var _this$props = this.props,
          defaultSelectedTab = _this$props.defaultSelectedTab,
          betTabIsSelected = _this$props.betTabIsSelected,
          onTabClick = _this$props.onTabClick,
          selectedTab = _this$props.selectedTab,
          subject = _this$props.subject;

      if (!this.getShouldShowActionsRedesign() || betTabIsSelected) {
        var className = (0, _classnames.default)({
          'p-x-4': betTabIsSelected
        });
        return _react.default.createElement("div", {
          className: className
        }, _react.default.createElement(_ProfileTimelineTabs.default, {
          defaultSelected: defaultSelectedTab,
          onTabClick: onTabClick,
          selected: selectedTab,
          subject: subject
        }));
      }

      return _react.default.createElement(DividingLineDiv, {
        className: "p-left-4 m-x-8 align-stretch justify-between flex-row"
      }, _react.default.createElement("div", {
        className: "flex-grow-1"
      }, _react.default.createElement(_ProfileTimelineTabs.default, {
        defaultSelected: defaultSelectedTab,
        onTabClick: onTabClick,
        selected: selectedTab,
        subject: subject
      })), this.renderInteractionActionsDropdown());
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          activityTabIsSelected = _this$props2.activityTabIsSelected,
          events = _this$props2.events,
          objectType = _this$props2.objectType,
          pinnedEngagement = _this$props2.pinnedEngagement,
          timelineStatus = _this$props2.timelineStatus;
      return _react.default.createElement("div", {
        className: "width-100"
      }, this.renderProfileActionSearch(), this.renderProfileSequencesModal(), this.renderTabs(), _react.default.createElement("div", {
        className: "p-x-8 p-top-4"
      }, _react.default.createElement(_TimelineFilters.default, {
        activityTabIsSelected: activityTabIsSelected,
        hasEvents: (0, _TimelineEventHelpers.hasEvents)(events, timelineStatus, !!pinnedEngagement),
        objectType: objectType
      }), this.renderCommunicatorButtons()));
    }
  }]);
  return TimelineControls;
}(_react.Component);

exports.WrappedComponent = TimelineControls;
TimelineControls.contextType = _SubjectContext.SubjectContext;
TimelineControls.propTypes = propTypes;

var _default = (0, _generalStore.connect)(dependencies)(TimelineControls);

exports.default = _default;